import { faTag } from '@fortawesome/pro-solid-svg-icons';
import {
  GenericSelectorModalConfig,
  GenericNodeComponentConfig,
} from '../shared';

/**
 * OpenPaymentsCategory item interface for ui_metadata storage
 */
export interface OpenPaymentsCategoryItem {
  id: string;
  displayLabel: string;
  name: string;
}

/**
 * Transform API response to OpenPaymentsCategoryItem format
 */
export const transformOpenPaymentsCategory = (apiItem: {
  id: string | number;
  name: string;
}): OpenPaymentsCategoryItem => ({
  id: String(apiItem.id),
  displayLabel: apiItem.name,
  name: apiItem.name,
});

/** Modal configuration for OpenPaymentsCategory selector */
export const openPaymentsCategoryModalConfig: GenericSelectorModalConfig<OpenPaymentsCategoryItem> =
  {
    title: 'Select Open Payments Category',
    searchPlaceholder: 'Search open payments categories...',
    emptyStateIcon: faTag,
    emptyStateMessage: 'No category selected',
    noResultsMessage: (searchTerm) => `No categories found for "${searchTerm}"`,
    colorTheme: 'violet',
    selectionMode: 'single',
    showConnectorToggle: false,
    defaultConnector: 'ANY',
    getItemLabel: (item) => item.name,
    getItemKey: (item) => item.id,
    isItemSelected: (item, selectedItems) =>
      selectedItems.some((s) => s.id === item.id),
    itemLabel: 'category',
    itemLabelPlural: 'categories',
  };

/** Node display configuration for OpenPaymentsCategory */
export const openPaymentsCategoryNodeConfig: GenericNodeComponentConfig<OpenPaymentsCategoryItem> =
  {
    colorTheme: 'violet',
    getItemLabel: (item) => item.name,
    getItemKey: (item) => item.id,
    maxVisibleItems: 1, // Single selection
    showConnectorLabel: false,
  };
